import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Container, Grid, Card, CardMedia } from '@mui/material';
import InnerPageBanner from '../../../components/InnerPageBanner';

// Import all variety images
import cobbStone1 from '../../../assets/images/CobblestoneMachineCut1.jpeg';
import cobbStone2 from '../../../assets/images/CobblestoneMachineCut2.jpeg';
import cobbStone3 from '../../../assets/images/CobblestoneMachineCut3.jpeg';
import cobbStone4 from '../../../assets/images/CobblestoneMachineCut4.jpeg';
import cobbStone5 from '../../../assets/images/CobblestoneMachineCut5.jpeg';
import cobbStone6 from '../../../assets/images/CobblestoneMachineCut6.jpeg';
import cobbStone7 from '../../../assets/images/CobblestoneMachineCut7.jpeg';
import cobbStone8 from '../../../assets/images/CobblestoneMachineCut8.jpeg';
import cobbStone9 from '../../../assets/images/CobblestoneMachineCut9.jpeg';
import cobbStone10 from '../../../assets/images/CobblestoneMachineCut10.jpeg';
import cobbStone11 from '../../../assets/images/CobblestoneMachineCut11.jpeg';
import cobbStone12 from '../../../assets/images/CobblestoneMachineCut12.jpeg';
import cobbStone13 from '../../../assets/images/CobblestoneMachineCut13.jpeg';
import cobbStone14 from '../../../assets/images/CobblestoneMachineCut14.jpeg';
import cobbStone15 from '../../../assets/images/CobblestoneMachineCut15.jpeg';
import cobbStone16 from '../../../assets/images/CobblestoneMachineCut16.jpeg';

import cobbStone17 from '../../../assets/images/Cobb stone Hand Cut Natural1.jpeg';
import cobbStone18 from '../../../assets/images/Cobb stone Hand Cut Natural2.jpeg';
import cobbStone19 from '../../../assets/images/Cobb stone Hand Cut Natural3.jpeg';
import cobbStone20 from '../../../assets/images/Cobb stone Hand Cut Natural4.jpeg';
import cobbStone21 from '../../../assets/images/Cobb stone Hand Cut Natural5.jpeg';
import cobbStone22 from '../../../assets/images/Cobb stone Hand Cut Natural6.jpeg';
import cobbStone23 from '../../../assets/images/Cobb stone Hand Cut Natural7.jpeg';
import cobbStone24 from '../../../assets/images/Cobb stone Hand Cut Natural8.jpeg';
import cobbStone25 from '../../../assets/images/Cobb stone Hand Cut Natural9.jpeg';
import cobbStone26 from '../../../assets/images/Cobb stone Hand Cut Natural10.jpeg';
import cobbStone27 from '../../../assets/images/Cobb stone Hand Cut Natural11.jpeg';
import cobbStone28 from '../../../assets/images/Cobb stone Hand Cut Natural12.jpeg';
import cobbStone29 from '../../../assets/images/Cobb stone Hand Cut Natural13.jpeg';
import cobbStone30 from '../../../assets/images/Cobb stone Hand Cut Natural14.jpeg';

import cobbStone31 from '../../../assets/images/Machine Cut 3line Dressing1.jpeg';
import cobbStone32 from '../../../assets/images/Machine Cut 3line Dressing2.jpeg';
import cobbStone33 from '../../../assets/images/Machine Cut 3line Dressing3.jpeg';
import cobbStone34 from '../../../assets/images/Machine Cut 3line Dressing4.jpeg';
import cobbStone35 from '../../../assets/images/Machine Cut 3line Dressing5.jpeg';
import cobbStone36 from '../../../assets/images/Machine Cut 3line Dressing6.jpeg';
import cobbStone37 from '../../../assets/images/Machine Cut 3line Dressing7.jpeg';
import cobbStone38 from '../../../assets/images/Machine Cut 3line Dressing8.jpeg';
import cobbStone39 from '../../../assets/images/Machine Cut 3line Dressing9.jpeg';
import cobbStone40 from '../../../assets/images/Machine Cut 3line Dressing10.jpeg';
import cobbStone41 from '../../../assets/images/Machine Cut 3line Dressing11.jpeg';
import cobbStone42 from '../../../assets/images/Machine Cut 3line Dressing12.jpeg';

import cobbStone43 from '../../../assets/images/Machine Cut Fleming1.jpeg';
import cobbStone44 from '../../../assets/images/Machine Cut Fleming2.jpeg';
import cobbStone45 from '../../../assets/images/Machine Cut Fleming3.jpeg';
import cobbStone46 from '../../../assets/images/Machine Cut Fleming4.jpeg';
import cobbStone47 from '../../../assets/images/Machine Cut Fleming5.jpeg';
import cobbStone48 from '../../../assets/images/Machine Cut Fleming6.jpeg';
import cobbStone49 from '../../../assets/images/Machine Cut Fleming7.jpeg';

import cobbStone50 from '../../../assets/images/Machine Cut 2line Dressing1.jpeg';
import cobbStone51 from '../../../assets/images/Machine Cut 2line Dressing2.jpeg';

import cobbStone52 from '../../../assets/images/Full Box Cut Natural Face1.jpeg';
import cobbStone53 from '../../../assets/images/Full Box Cut Natural Face2.jpeg';
import cobbStone54 from '../../../assets/images/Full Box Cut Natural Face3.jpeg';
import cobbStone55 from '../../../assets/images/Full Box Cut Natural Face4.jpeg';
import cobbStone56 from '../../../assets/images/Full Box Cut Natural Face5.jpeg';
import cobbStone57 from '../../../assets/images/Full Box Cut Natural Face6.jpeg';
import cobbStone58 from '../../../assets/images/Full Box Cut Natural Face7.jpeg';
import cobbStone59 from '../../../assets/images/Full Box Cut Natural Face8.jpeg';
import cobbStone60 from '../../../assets/images/Full Box Cut Natural Face9.jpeg';
import cobbStone61 from '../../../assets/images/Full Box Cut Natural Face10.jpeg';
import cobbStone62 from '../../../assets/images/Full Box Cut Natural Face11.jpeg';
import cobbStone63 from '../../../assets/images/Full Box Cut Natural Face12.jpeg';
import cobbStone64 from '../../../assets/images/Full Box Cut Natural Face13.jpeg';
import cobbStone65 from '../../../assets/images/Full Box Cut Natural Face14.jpeg';
import cobbStone66 from '../../../assets/images/Full Box Cut Natural Face15.jpeg';
import cobbStone67 from '../../../assets/images/Full Box Cut Natural Face16.jpeg';
import cobbStone68 from '../../../assets/images/Full Box Cut Natural Face17.jpeg';
import cobbStone69 from '../../../assets/images/Full Box Cut Natural Face18.jpeg';
import cobbStone70 from '../../../assets/images/Full Box Cut Natural Face19.jpeg';
import cobbStone71 from '../../../assets/images/Full Box Cut Natural Face20.jpeg';
import cobbStone72 from '../../../assets/images/Full Box Cut Natural Face21.jpeg';
import cobbStone73 from '../../../assets/images/Full Box Cut Natural Face22.jpeg';
import cobbStone74 from '../../../assets/images/Full Box Cut Natural Face23.jpeg';
import cobbStone75 from '../../../assets/images/Full Box Cut Natural Face24.jpeg';
import cobbStone76 from '../../../assets/images/Full Box Cut Natural Face25.jpeg';
import cobbStone77 from '../../../assets/images/Full Box Cut Natural Face26.jpeg';
import cobbStone78 from '../../../assets/images/Full Box Cut Natural Face27.jpeg';

const categoryData = {
    'machine-cut-natural-face': {
        title: "Machine Cut Natural Face",
        images: [
            cobbStone1, cobbStone2, cobbStone3, cobbStone4,
            cobbStone5, cobbStone6, cobbStone7, cobbStone8,
            cobbStone9, cobbStone10, cobbStone11, cobbStone12,
            cobbStone13, cobbStone14, cobbStone15, cobbStone16
        ]
    },
    'hand-cut-natural': {
        title: "Hand Cut Natural",
        images: [
            cobbStone17, cobbStone18, cobbStone19, cobbStone20,
            cobbStone21, cobbStone22, cobbStone23, cobbStone24,
            cobbStone25, cobbStone26, cobbStone27, cobbStone28,
            cobbStone29, cobbStone30
        ]
    },
    'machine-cut-3line-dressing': {
        title: "Machine Cut 3Line Dressing (Bush Hammer)",
        images: [
            cobbStone31, cobbStone32, cobbStone33, cobbStone34,
            cobbStone35, cobbStone36, cobbStone37, cobbStone38,
            cobbStone39, cobbStone40, cobbStone41, cobbStone42
        ]
    },
    'machine-cut-fleming-face': {
        title: "Machine Cut Fleming Face",
        images: [
            cobbStone43, cobbStone44, cobbStone45, cobbStone46,
            cobbStone47, cobbStone48, cobbStone49
        ]
    },
    'machine-cut-2line-dressing': {
        title: "Machine Cut 2Line Dressing",
        images: [
            cobbStone50, cobbStone51
        ]
    },
    'full-edge-box-cut': {
        title: "Full Edge Box Cut",
        images: [
            cobbStone52, cobbStone53, cobbStone54, cobbStone55,
            cobbStone56, cobbStone57, cobbStone58, cobbStone59,
            cobbStone60, cobbStone61, cobbStone62, cobbStone63,
            cobbStone64, cobbStone65, cobbStone66, cobbStone67,
            cobbStone68, cobbStone69, cobbStone70, cobbStone71,
            cobbStone72, cobbStone73, cobbStone74, cobbStone75,
            cobbStone76, cobbStone77, cobbStone78
        ]
    }
};

const CobbleStoneDetail = () => {
    const { id } = useParams();
    const data = categoryData[id] || { title: "Cobble Stone", images: Array(8).fill(cobbStone1) };

    const breadcrumbs = [
        { label: 'Cobble Stone', link: '/cobble-stone' },
        { label: data.title }
    ];

    return (
        <Box>
            <InnerPageBanner title={data.title} breadcrumbs={breadcrumbs} />

            <Container sx={{ py: 8 }}>
                <Grid container spacing={4}>
                    {data.images.map((img, index) => (
                        <Grid item size={{ xs: 12, sm: 6, md: 6 }} key={index}>
                            <Card
                                sx={{
                                    borderRadius: 0,
                                    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                    overflow: 'hidden',
                                    transition: 'transform 0.3s ease-in-out',
                                    '&:hover': {
                                        transform: 'scale(1.02)'
                                    }
                                }}
                            >
                                <CardMedia
                                    component="img"
                                    height="400"
                                    image={img}
                                    alt={`${data.title} ${index + 1}`}
                                    sx={{
                                        objectFit: 'cover'
                                    }}
                                />
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default CobbleStoneDetail;
